/**
 *
 * PageBodyContainer
 *
 */
import { Stack } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import * as React from 'react';
import { CustomDimensions } from 'styles/theme/themes';

interface Props {
  children: React.ReactNode;
  size?: 'lg' | 'default' | 'lg' | 'xl' | 'full',
  sx?: SxProps,
}

const sizes = {
  default: CustomDimensions.bodyMaxWidth,
  lg: 1200,
  xl: 1800,
  full: 'unset'
}

export function PageBodyContainer(props: Props) {
  return (
    <Stack
      spacing={3}
      sx={{
        display: 'flex',
        maxWidth: sizes[props?.size || 'default'],
        mx: 'auto',
        width: '100%',
        p: props?.size ? 4 : 0,
        py: { xs: 2, md: 3 },
        ...(props.sx || {})
      }}
    >
      {props.children}
    </Stack>
  );
}
